// src/hooks/usePersistedFilter.js
import { useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    saveFilter,
    clearFilter,
    FILTER_PERSISTED_PAGES,
} from "../Redux/Filter/filterSlice.js";

/**
 * @param {string} pageKey - must be listed in FILTER_PERSISTED_PAGES
 */
export function usePersistedFilter(pageKey) {
    const dispatch = useDispatch();
    const filterRef = useRef(null);

    const isWhitelisted = FILTER_PERSISTED_PAGES.includes(pageKey);

    // Pull saved selections for this page from Redux
    const savedSelections = useSelector((state) =>
        isWhitelisted ? state.persistedFilters[pageKey] ?? null : null
    );

    // Wrap your onApply: saves to Redux, then calls your page's own handler
    const handleApply = useCallback(
        (selections, originalOnApply) => {
            if (isWhitelisted) {
                dispatch(saveFilter(pageKey, selections));
            }
            originalOnApply?.(selections);
        },
        [dispatch, pageKey, isWhitelisted]
    );

    // Clears Redux entry + resets Filter UI via imperative ref
    const handleClear = useCallback(() => {
        if (isWhitelisted) {
            dispatch(clearFilter(pageKey));
        }
        filterRef.current?.clear();
    }, [dispatch, pageKey, isWhitelisted]);

    return { filterRef, savedSelections, handleApply, handleClear };
}